import React, { useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadingPage from '../../components/LoadingPage';
import { getUser } from '../../../reducers';
import ListBids from './ListBids';
import NewBid from './NewBid';
import DetailsBid from './DetailsBid';
import { db, firestore } from '../../../config/Fire';
import * as Constants from '../../../constants';
import cloneDeep from 'lodash/cloneDeep';
import './styles.css';
import moment from 'moment';

const bidsPages = {
    LIST_BIDS: 'LIST_BIDS',
    NEW_BID: 'NEW_BID',
    DETAILS_BID: 'DETAILS_BID'
};

const BidsEmployee = props => {
    const { companyType = 'Arcasa' } = props
    const [bids, setBids] = useState(null);
    const [bidPage, setBidPage] = useState(bidsPages.LIST_BIDS);
    const [clients, setClients] = useState(null);
    const [employees, setEmployees] = useState(null);
    const [outsourcingOrders, setOutsourcingOrders] = useState(null);
    const [bidOrderIdToEdit, setBidOrderIdToEdit] = useState(null);
    const [works, setWorks] = useState(null);
    const [filteredBids, setFilteredBids] = useState(null);


    const getData = useCallback(() => {
        firestore.collection(`${Constants.MAIN_NODES.BID_ORDERS}`).get()
            .then(bidDocs => {
                const bidsLoaded = {};
                const bidsFiltered = {};
                if (!bidDocs.empty) {
                    bidDocs.forEach(bidDoc => {
                        const bid = bidDoc.data();
                        bidsLoaded[bid.id] = bid;
                        if (bid.company === companyType) bidsFiltered[bid.id] = bid;
                    });
                }
                db.ref(Constants.MAIN_NODES.USERS).once('value')
                    .then(usersSnap => {
                        const clientsLoaded = {};
                        const employeesLoaded = {};
                        if (usersSnap.exists()) {
                            usersSnap.forEach(userSnap => {
                                const user = userSnap.val();
                                if (user.userType === Constants.USER_TYPES.CLIENT) {
                                    clientsLoaded[user.id] = user;
                                }
                                if (user.userType === Constants.USER_TYPES.EMPLOYEE) {
                                    employeesLoaded[user.id] = user;
                                }
                            });
                        }
                        setClients(clientsLoaded);
                        setBids(bidsLoaded);
                        setFilteredBids(bidsFiltered);
                        setEmployees(employeesLoaded);
                    })
                    .catch(err => {
                        console.log('Error getting users: ' + JSON.stringify(err));
                    });
            })
            .catch(err => {
                console.log('Error getting bids: ' + JSON.stringify(err));
            });
        firestore.collection(`${Constants.MAIN_NODES.OUTSOURCING_ORDERS}`).get()
            .then(outsourcingDocs => {
                const outsourcingLoaded = {};
                if (!outsourcingDocs.empty) {
                    outsourcingDocs.forEach(outsourcingDoc => {
                        const outsourcing = outsourcingDoc.data();
                        outsourcingLoaded[outsourcing.id] = outsourcing;
                    });
                }
                setOutsourcingOrders(outsourcingLoaded);
            })
            .catch(err => {
                console.log('Error getting outsourcing orders: ' + JSON.stringify(err));
            });
        firestore.collection(`${Constants.MAIN_NODES.WORK_ORDERS}`).get()
            .then(workDocs => {
                const worksLoaded = {};
                if (!workDocs.empty) {
                    workDocs.forEach(workDoc => {
                        const work = workDoc.data();
                        worksLoaded[work.id] = work;
                    });
                }
                setWorks(worksLoaded);
            })
            .catch(err => {
                console.log('Error getting works: ' + JSON.stringify(err));
            });
    }, [companyType]);

    useEffect(() => {
        if (validateUser()) {
            getData();
        }
    }, [getData]);

    const onNewBidBack = (isNewBidOrder, newBidOrder) => {
        if (isNewBidOrder && newBidOrder) {
            const bidsLoaded = cloneDeep(bids);
            bidsLoaded[newBidOrder.id] = newBidOrder;
            setBids(bidsLoaded);
            // Agregar a filteredBids si pertenece a la empresa actual
            if (newBidOrder.company === companyType) {
                const bidsFilteredLoaded = cloneDeep(filteredBids);
                bidsFilteredLoaded[newBidOrder.id] = newBidOrder;
                setFilteredBids(bidsFilteredLoaded);
            }
            setBidPage(bidsPages.LIST_BIDS);
            window.location.reload()
        } else {
            setBidPage(bidsPages.LIST_BIDS);
        }
    };

    const onShowBidOrder = id => {
        if (id && bids && bids[id]) {
            setBidOrderIdToEdit(id);
            setBidPage(bidsPages.DETAILS_BID);
        }
    };

    const onBidOrderDeleted = id => {
        const bidsLoaded = cloneDeep(bids);
        if (id && bidsLoaded && bidsLoaded[id]) {
            delete bidsLoaded[id];
            delete filteredBids[id];
            setBids(bidsLoaded);
        }
    };

    const onDetailsBidBack = (editBidOrder, bidOrderToUpdate) => {
        if (editBidOrder && bidOrderToUpdate) {
            const worksLoaded = cloneDeep(bids);
            worksLoaded[bidOrderToUpdate.id] = bidOrderToUpdate;
            setBids(worksLoaded);
            setBidPage(bidsPages.LIST_BIDS);
        } else {
            setBidPage(bidsPages.LIST_BIDS);
        }
        window.location.reload()
    };

    const updateBidOrder = (bidOrderToUpdate) => {
        if (bidOrderToUpdate) {
            const bidsLoaded = cloneDeep(bids);
            bidsLoaded[bidOrderIdToEdit].company = bidOrderToUpdate.company;
            bidsLoaded[bidOrderIdToEdit].category = bidOrderToUpdate.category;
            bidsLoaded[bidOrderIdToEdit].clients = bidOrderToUpdate.clients;
            bidsLoaded[bidOrderIdToEdit].proyect = bidOrderToUpdate.proyect;
            bidsLoaded[bidOrderIdToEdit].hasTopography = bidOrderToUpdate.hasTopography;
            bidsLoaded[bidOrderIdToEdit].province = bidOrderToUpdate.province;
            bidsLoaded[bidOrderIdToEdit].city = bidOrderToUpdate.city;
            bidsLoaded[bidOrderIdToEdit].billing = bidOrderToUpdate.billing;
            bidsLoaded[bidOrderIdToEdit].amountPesos = bidOrderToUpdate.amountPesos;
            bidsLoaded[bidOrderIdToEdit].amountDollars = bidOrderToUpdate.amountDollars;
            bidsLoaded[bidOrderIdToEdit].paymentForm = bidOrderToUpdate.paymentForm;
            bidsLoaded[bidOrderIdToEdit].paymentTerm = bidOrderToUpdate.paymentTerm;
            bidsLoaded[bidOrderIdToEdit].outsourcing = bidOrderToUpdate.outsourcing;
            bidsLoaded[bidOrderIdToEdit].outsourcingAmount = bidOrderToUpdate.outsourcingAmount;
			bidsLoaded[bidOrderIdToEdit].quotedEngineeringDays = bidOrderToUpdate.quotedEngineeringDays ?? null
			bidsLoaded[bidOrderIdToEdit].predictedKilometers = bidOrderToUpdate.predictedKilometers ?? null
			bidsLoaded[bidOrderIdToEdit].items = bidOrderToUpdate.items ?? []
			bidsLoaded[bidOrderIdToEdit].totalDays = bidOrderToUpdate.totalDays ?? 0
            bidOrderToUpdate.startDate = moment(bidOrderToUpdate.startDate, 'DD/MM/YYYY');
            let month = bidOrderToUpdate.startDate.month() + 1 < 10 ? `0${bidOrderToUpdate.startDate.month() + 1}` : bidOrderToUpdate.startDate.month() + 1;
            let customDate = `${bidOrderToUpdate.startDate.date()}/${month}/${bidOrderToUpdate.startDate.year()}`;
            bidOrderToUpdate.startDate = customDate;
            bidsLoaded[bidOrderIdToEdit].startDate = bidOrderToUpdate.startDate;
            setBids(bidsLoaded);
            // Actualizar filteredBids si el bidOrder actualizado pertenece a la empresa actual
            if (bidOrderToUpdate.company === companyType) {
                const bidsFilteredLoaded = cloneDeep(filteredBids);
                bidsFilteredLoaded[bidOrderIdToEdit] = bidOrderToUpdate;
                setFilteredBids(bidsFilteredLoaded);
            } else {
                // Si cambió de empresa, eliminarlo del filtro
                const bidsFilteredLoaded = cloneDeep(filteredBids);
                if (bidsFilteredLoaded[bidOrderIdToEdit]) {
                    delete bidsFilteredLoaded[bidOrderIdToEdit];
                    setFilteredBids(bidsFilteredLoaded);
                }
            }
            setBidPage(bidsPages.LIST_BIDS);
            window.location.reload()
        }
    };

    // Ya no se actualiza workOrderId en bids - ahora la relación es solo por bidId en works
    // const updateBidData = (updated, workOrderId, bidOrder) => {
    //     if (updated && workOrderId && bidOrder) {
    //         const bidsLoaded = cloneDeep(bids);
    //         bidsLoaded[bidOrder.id].workOrderId = workOrderId;
    //         setBids(bidsLoaded);
    //     }
    // };

    const validateUser = () => {
        if (props.user && props.user.id && Constants.VALID_USERS_IDS.includes(props.user.id)) {
            return true;
        }
        return false;
    };

    const renderWorkPage = bidPage => {
        switch (bidPage) {
            case bidsPages.LIST_BIDS:
                return <ListBids works={works} bids={filteredBids} outsourcing={outsourcingOrders} employees={employees} clients={clients} onBidOrderDeleted={onBidOrderDeleted}
                    onShowBidOrder={onShowBidOrder} onNewBidSelected={() => setBidPage(bidsPages.NEW_BID)}
                    onBack={() => {}} companyType={companyType} />; // Ya no se actualiza workOrderId en bids
            case bidsPages.DETAILS_BID:
                return <DetailsBid bidOrderToEdit={bids[bidOrderIdToEdit]} employees={employees} clients={clients} outsourcing={outsourcingOrders} onBack={onDetailsBidBack} onUpdateBidOrder={updateBidOrder} />;
            case bidsPages.NEW_BID:
                return <NewBid clients={clients} outsourcing={outsourcingOrders} onBack={onNewBidBack} companyType={companyType} />;
            default:
                return <ListBids onNewBidSelected={() => setBidPage(bidsPages.NEW_BID)} companyType={companyType} />;
        }
    };

    return (
        <div className="bidsEmployeeCont">
            {
                validateUser() ?
                    bids !== null ?
                        renderWorkPage(bidPage)
                        :
                        <LoadingPage />
                    :
                    <h1 className='message'>No tiene permisos para acceder a esta sección</h1>
            }
        </div>
    );
};

BidsEmployee.propTypes = {};

const mapDispatchToPropsActions = dispatch => ({});

const mapStateToProps = state => ({
    user: getUser(state)
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(BidsEmployee));